module.exports = __webpack_public_path__ + "../DTFT/appsettings.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=../DTFT/[name].[ext]!./configs/appSettings/DTFT/appsettings.js
// module id = 755
// module chunks = 1